// icons
import { MdDashboardCustomize } from "react-icons/md";

const tasksBoard = {
    id: 'tasks-board-group',
    type: 'group',
    roles: [1],
    breadcrumbs: false,
    children: [
      {
        id: 'tasks-board',
        title: "Tasks board",
        type: 'item',
        breadcrumbs: false,
        icon: MdDashboardCustomize,
        url: '/tasks-board'
      }
    ]
  };

export default tasksBoard;
